import selectLocalExercise from './selectLocalExercise';
const selectExercise = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return [];
  }
  return localExercise.feedbackMessages.map(feedbackId => state.feedbackMessages[feedbackId]);
};
export default selectExercise;